import {ArrowRight, Check, Download, FileText, ListOrdered, Users} from '@nlabs/gothamjs/icons';

import type {ReactElement} from 'react';

const contents = [
  {icon: ListOrdered, label: 'Shot plan'},
  {icon: Users, label: 'Cast & direction'},
  {icon: Check, label: 'Selected takes'}
];

export const ManifestExportVisual = (): ReactElement => (
  <>
    <div className="mb-4 flex items-center justify-between text-[9px] tracking-[.14em] text-white/55"><span>PROJECT HANDOFF</span><span className="text-violet-300">ONE FILE</span></div>
    <div className="flex h-28 items-center gap-2.5">
      <div className="min-w-0 flex-1 space-y-2">{contents.map(({icon: Icon, label}) => (
        <div className="flex items-center gap-2 rounded-lg border border-white/10 bg-white/4 px-2.5 py-2 text-[9px] text-white/75" key={label}><Icon className="shrink-0 text-sky-200" size={12} /><span>{label}</span></div>
      ))}</div>
      <ArrowRight className="shrink-0 text-violet-300/75" size={15} />
      <div className="relative flex h-28 w-24 shrink-0 flex-col overflow-hidden rounded-xl border border-violet-200/60 bg-linear-to-br from-violet-100 to-violet-300 p-3 text-violet-950 shadow-lg shadow-violet-950/30">
        <span className="absolute top-0 right-0 size-5 rounded-bl-lg border-b border-l border-violet-950/10 bg-white/50" />
        <FileText size={22} strokeWidth={1.5} />
        <p className="mt-2 text-[9px] font-semibold tracking-wide">MANIFEST</p>
        <div className="mt-2 space-y-1"><span className="block h-1 w-full rounded-full bg-violet-950/20" /><span className="block h-1 w-3/4 rounded-full bg-violet-950/15" /><span className="block h-1 w-1/2 rounded-full bg-violet-950/10" /></div>
      </div>
    </div>
    <div className="mt-4 flex items-center gap-3 rounded-xl border border-violet-300/25 bg-violet-400/10 px-3 py-2.5">
      <div className="min-w-0 flex-1"><p className="text-[10px] font-medium text-violet-100">project-manifest.json</p><p className="mt-1 text-[9px] text-white/50">Your story plan, ready to carry forward.</p></div>
      <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-violet-300 text-violet-950"><Download size={14} /></span>
    </div>
  </>
);
